import PropTypes from 'prop-types';
import { List } from 'immutable';
import React from 'react';

import { Dropdown, Option as DropdownOption } from '../../../widgets/Dropdown';

import style from './ActiveFilters.module.scss';

const STATUSES = [
  { id: 'all', value: 'all', name: 'All' },
  { id: 'matched Only', value: 'matched', name: 'Matched Only' },
  { id: 'unmatched Only', value: 'unmatched', name: 'Unmatched Only' },
];

const SIDES = [
  { id: 'back&lay', value: 'back&lay', name: 'Back & Lay' },
  { id: 'back', value: 'back', name: 'Back Only' },
  { id: 'lay', value: 'lay', name: 'Lay Only' },
];

const ActiveFilters = ({
  activeSports,
  setActiveFilters,
  activeFilters,
}) => {
  const SPORTS = activeSports.toArray();

  SPORTS.unshift(
    { id: 'all', value: 'all', name: 'All Sports' },
    { id: 'dynamic', value: 'dynamic', name: 'Dynamic' }
  );

  const { name: selectedStatus } = STATUSES.find(d => d.value === activeFilters.status) || {};
  const { name: selectedSport } = SPORTS.find(d => d.id === activeFilters.sport) || {};
  const { name: selectedSide } = SIDES.find(d => d.id === activeFilters.side) || {};

  const handleSelectStatus = (option) => {
    setActiveFilters({ status: option.value });
  };

  const handleSelectSport = (option) => {
    setActiveFilters({ sport: option.id });
  };

  const handleSelectSide = (option) => {
    setActiveFilters({ side: option.value });
  };

  return (
    <div className={style.filtersContainer}>
      <Dropdown
        theme="dark"
        layout="small"
        useDesktopDropdown
        items={STATUSES}
        selectLabel={selectedStatus || STATUSES[0].name}
        onSelect={(value) => handleSelectStatus(value)}
      >
        {STATUSES.map(option => (
          <DropdownOption
            key={option.id}
            value={option}
          >
            {option.name}
          </DropdownOption>))
        }
      </Dropdown>
      <Dropdown
        theme="dark"
        layout="small"
        useDesktopDropdown
        items={SPORTS}
        selectLabel={selectedSport || SPORTS[0].name}
        onSelect={(value) => handleSelectSport(value)}
      >
        {SPORTS.map(option => (
          <DropdownOption
            key={option.id}
            value={option}
          >
            {option.name}
          </DropdownOption>))
        }
      </Dropdown>
      <Dropdown
        theme="dark"
        layout="small"
        useDesktopDropdown
        items={SIDES}
        selectLabel={selectedSide || SIDES[0].name}
        onSelect={(value) => handleSelectSide(value)}
      >
        {SIDES.map(option => (
          <DropdownOption
            key={option.id}
            value={option}
          >
            {option.name}
          </DropdownOption>))
        }
      </Dropdown>
    </div>
  );
};

ActiveFilters.propTypes = {
  activeSports: PropTypes.instanceOf(List).isRequired,
  setActiveFilters: PropTypes.func.isRequired,
  activeFilters: PropTypes.instanceOf(Object),
};

export default ActiveFilters;
